module.exports = __webpack_public_path__ + "static/img/banner_solution.0eb4dc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_solution.jpg
// module id = z0s3
// module chunks = 1